<template lang="html">
	<section class="ctn-patrimonial-landscape no-edit">
		<div class="head row">
			<h1>Mon Paysage Patrimonial</h1>
			<!-- <div class="ctn-cta" v-if="!isAnonymous">
				<div class="btn btn-disabled"><span class="icon-info-2"></span> Patrimoffcie est également expert en conseil pour les entreprises</div>
				<div class="btn btn-red" @click="goToSubscribeEnterprise">Inscription Entreprise</div>
			</div> -->
		</div>
		<display></display>
	</section>
</template>

<script>
import display from '@/common/components/MyPatrimonialLandscape/Display'
import { mapGetters } from 'vuex'
export default {
	name: 'IndexPatrimonialLandscape',
	components: {
		display
	},
	methods: {
		goToSubscribeEnterprise () {
			this.$store.dispatch('allClear')
			this.$router.push({ name: 'EnterpriseSubscribe' })
		}
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAnonymous: 'isAnonymous'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Documents/PatrimonialLandscape/PatrimonialLandscape.vue